module.exports = __webpack_public_path__ + "static/morningside-manor-cc49f6475b2085b5b6843c4bceb19205.jpeg";